<template>
    <div class="settings">
        <span class="card-title">Settings</span>
        <div class="settings-outer">
            <div class="settings-inner">
                <button class="btn link" @click="toggleTheme()">
                    <icon>theme-light-dark</icon>
                    <span>&nbsp;Switch to {{ darkmode ? 'light' : 'dark' }} theme</span>
                </button>
                <h4>Plugins</h4>
                <div class="plugin-selector input-group">
                    <!-- <span class="input-group-addon">plugin</span> -->
                    <select v-model="ipluginName" class="input">
                        <option v-for="(pluginName) in pluginNames" :value="pluginName ? pluginName : ''" :key="pluginName + '_' + (pluginName ? isPluginInstalled(pluginName) : '')">
                            {{ pluginName ? pluginName : 'Please select a plugin' }} <i v-if="pluginName && isPluginInstalled(pluginName)">(installed)</i>
                        </option>
                    </select>
                </div>
                <div class="plugin-selector input-group">
                    <input class="input" type="text" v-model="ipluginName" placeholder="pluginName" />
                </div>
                <div>
                    <button type="submit" @click="install" class="btn secondary" :disabled="!ipluginName || isPluginInstalled(ipluginName)">Install plugin</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from './Icon';
import { mapGetters } from 'vuex';

export default {
    name: 'Settings',
    components: {
        Icon
    },
    data() {
        return {
            pluginNames: [
                '',
                'markdown',
                'emojione',
                'tempsaveMsginput',
                'pushNotification',
            ],
            ipluginName: '',
            darkmode: document.getElementById("html").classList.contains("darkmode") || false
        };
    },
    computed: {
        ...mapGetters(['isPluginInstalled'])
    },
    methods: {
        install() {
            if (this.ipluginName) {
                this.installPlugin(this.ipluginName);
                this.ipluginName = '';
            }
        },
        toggleTheme() {
            document.getElementById("html").classList.toggle("darkmode");
            const darkmode = document.getElementById("html").classList.contains("darkmode") || false;
            this.darkmode = darkmode;
        }
    }
};
</script>
